export default __webpack_public_path__ + "static/media/chai.ee9f70b2.svg";